<template>
  <div>
    <!-- 頭部 -->
    <headers :nav-index="1"></headers>

    <div class="p-Top-58" :style="{minHeight: contentMinHeight}">
      <!-- 資訊分類 -->
      <news-sort :select-cate="searchParam.cate_id"></news-sort>
      <!-- 資訊列表 -->
      <div class="news-list-box">
        <div class="list-con">
          <news-list :news-list="newsList"></news-list>
        </div>
        <div class="page-box">
          <a-pagination
                  size="small"
                  :current="searchParam.current_page"
                  :defaultPageSize="searchParam.per_page"
                  :total="listTotal"
                  show-quick-jumper
                  @change="onPageChange"
          />
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <footers></footers>
  </div>
</template>

<script>
import headers from "./components/header";
import footers from "./components/footer";
import newsSort from "./components/newsSort";
import newsList from "./components/newsList";

import { pageQueryArticle } from "@/api/index";
export default {
  name: "news",
  components: {
    headers,
    footers,
    newsSort,
    newsList,
  },
  data() {
    return {
      contentMinHeight:'',
      searchParam: {
        current_page: 1,
        per_page: 4,
        cate_id: 0,
        order: {},
        is_information:1
      },
      listTotal: 0,
      newsList: [],
    };
  },
  watch: {
    $route: {
      handler() {
        let cate = ~~this.$route.params.cate;
        this.searchParam.current_page = 1;
        this.searchParam.cate_id = cate ? cate : 0;
        this.pageQueryArticle();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.contentMinHeight = setHeight()
  },
  methods: {
    pageQueryArticle() {
      pageQueryArticle(this.searchParam).then((res) => {
        this.newsList = res.data.data;
        this.listTotal = res.data.total;
      });
    },
    onPageChange(page, pageSize) {
      this.searchParam.current_page = page;
      this.pageQueryArticle();
    },
  },
};
</script>

<style lang="less" scoped>
  *{
    font-family: Noto Sans SC,PingFang SC,Avenir Next,ST Heiti,Hiragino Sans GB,Microsoft YaHei,sans-serif;
  }
.news-list-box {
  max-width: 1360px;
  padding: 0 10px;
  margin: 30px auto;
  .page-box {
    display: flex;
    justify-content: center;
    padding: 40px 0;
  }
}
@media (max-width: 767px) {
  .news-list-box {
    margin: 20px auto;
    padding: 0 20px;
    .page-box {
      padding: 25px 0;
    }
  }
}
</style>
